import { Skeleton } from 'antd';
import { formatSeconds } from '@/utils';
import { BODY_PART, MassageType2Text, OrderState } from '@/constant';
import cx from './index.module.scss';

export const ServiceDetailHeader = ({
  serviceDetail,
  isGettingData,
}: {
  isGettingData: boolean;
  serviceDetail: GetServiceOrderDetailResponse;
}) => {
  return (
    <div className={cx('header-card')} style={{ backgroundImage: `url(${serviceDetail?.coverSelectedImage})` }}>
      <Skeleton loading={isGettingData} title={false} paragraph={{ rows: 0 }}>
        <div className={cx('top-desc')}>
          <div className={cx('title')}>{serviceDetail?.goodsName}</div>
          <div className={cx('status', serviceDetail?.state?.toLowerCase())}>{OrderState[serviceDetail?.state]}</div>
        </div>
        <div
          className={cx('center-desc', {
            hide: !serviceDetail?.manualDuration && !serviceDetail?.machineDuration,
          })}
        >
          <div className={cx('text')}>进行了</div>
          {!!serviceDetail?.machineDuration && (
            <div className={cx('massage-type')}>
              <div className={cx('text')}>
                <span>机器理疗</span>
                <span className={cx('value')}>{formatSeconds(serviceDetail?.machineDuration)}</span>
              </div>
            </div>
          )}
          {!!serviceDetail?.manualDuration && (
            <div className={cx('massage-type')}>
              <div className={cx('text')}>
                <span>人工理疗</span>
                <span className={cx('value')}>{formatSeconds(serviceDetail?.manualDuration)}</span>
              </div>
            </div>
          )}
          <div className={cx('text')}>{serviceDetail?.effectText}</div>
        </div>
        <div className={cx('bottom-desc')}>
          <div className={cx('item')}>
            <span className={cx('label')}>理疗类型：</span>
            <span className={cx('value')}>{MassageType2Text?.[serviceDetail?.itemType]}</span>
          </div>

          <div className={cx('item', 'more-item')}>
            <div>
              <span className={cx('label')}>创建时间：</span>
              <span className={cx('value')}>{serviceDetail?.createTime}</span>
            </div>
            <div>
              <span className={cx('label')}>机器人：</span>
              <span className={cx('value')}>{serviceDetail?.deviceId}</span>
            </div>

            {!['All', 'LowerBody']?.includes(serviceDetail?.bodyPart) && (
              <div>
                <span className={cx('label')}>部位：</span>
                <span className={cx('value')}>{BODY_PART?.[serviceDetail?.bodyPart]}</span>
              </div>
            )}
          </div>
        </div>
      </Skeleton>
    </div>
  );
};
